const APP_FONT_SIZE = 'LOGIN'

const state = {
    appFontSize: 16
}

const mutations = {
    [APP_FONT_SIZE](state, value) {
        state.appFontSize = value
    },
}

const actions = {
    setAppFontSize({commit}, value) {
        commit(APP_FONT_SIZE, value)
    }
}

const getters = {
    getAppFontSize: state => {
        return state.appFontSize
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
